import imageCompression from 'browser-image-compression';
import { isLikelyImageFile } from './imageFileTypes';

/**
 * Réduit le poids des photos avant upload (côté client, Web Worker si possible).
 * @param {File} file
 * @param {object} [opts] - surcharge (maxSizeMB, maxWidthOrHeight, initialQuality, useWebWorker, …)
 * @returns {Promise<File>}
 */
const DEFAULT_OPTIONS = {
  maxSizeMB: 1.2,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  initialQuality: 0.85,
  /** Toujours du JPEG : sinon WebP conserve image/webp alors que le nom finit en .jpg → Outlook ne l’affiche pas dans les courriels. */
  fileType: 'image/jpeg',
};

export async function compressImageFileForUpload(file, opts = {}) {
  if (!file || !isLikelyImageFile(file)) return file;

  const isWebp = file.type === 'image/webp' || /\.webp$/i.test(file.name || '');
  const useWorker =
    opts.useWebWorker !== undefined ? opts.useWebWorker : !isWebp && !!file.type;

  try {
    const compressed = await imageCompression(file, {
      ...DEFAULT_OPTIONS,
      ...opts,
      useWebWorker: useWorker,
    });

    const out =
      compressed instanceof File
        ? compressed
        : new File(
            [compressed],
            (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg',
            { type: 'image/jpeg' },
          );

    // WebP : garder la sortie JPEG même si plus lourde, pour URLs .jpg + clients mail (Outlook).
    if (!isWebp && out.size >= file.size) return file;
    return out;
  } catch {
    return file;
  }
}
